import * as yup from "yup";
import fileSchema from "../../../utils/yup/fileSchema";
import moneySchema from "../../../utils/yup/moneySchema";

export const productInputSchema = yup.object({
  name: yup.string().required("Ingrese un nombre para el producto"),
  price: moneySchema.required("Ingrese un precio estimado del producto"),
  description: yup
    .string()
    .required("Ingrese una descripción para el producto"),
  image: fileSchema.required("Ingrese una imagen para el producto"),
});
